<mat-card>
    <mat-card-header style="margin-bottom: 20px">
        <mat-card-title>Estrutura Familiar</mat-card-title>
        <button
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="ADICIONAR ESTRUTURA FAMILIAR"
            (click)="openCadastro()">
            <mat-icon>add_circle</mat-icon>
        </button>
    </mat-card-header>
    <mat-card-content>
        <ngx-datatable 
            #table 
            class='material striped' 
            [loadingIndicator]="loadingIndicator"
            [columns]="columns" 
            [columnMode]="'force'" 
            [headerHeight]="50"                       
            [footerHeight]="50" 
            [rowHeight]="'auto'"                      
            (sort)="onSort($event)"
            [rows]='rows'
        >
            <ngx-datatable-column 
                name="Nome" 
                matTooltip='Nome' 
                prop="nome" 
                [sortable]="true">

                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.nome}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Data de nascimento" 
                matTooltip='Data de nascimento' 
                prop="data_nascimento" 
                [sortable]="true">

                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.data_nascimento | date:'dd/MM/yyyy'}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Idade" 
                matTooltip='Idade' 
                prop="idade" 
                [sortable]="true">

                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.idade}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Estado Civil" 
                matTooltip='Estado Civil' 
                prop="estado_civil" 
                [sortable]="true">

                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{ getNomeEstaoCivil(row) }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Parentesco" 
                matTooltip='Parentesco' 
                prop="parentesco" 
                [sortable]="true">

                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.parentesco.nome}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Sexo" 
                matTooltip='Sexo' 
                prop="sexo" 
                [sortable]="true">

                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.desc_sexo}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
                name="Profissão"
                matTooltip='Profissão' 
                prop="profissao" 
                [sortable]="true">

                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    {{row.profissao?.nome}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                    
                    <button mat-icon-button matTooltip="Altera Item" (click)="openAlterar(row.id)">
                        <mat-icon aria-label="Editar">edit</mat-icon>
                    </button>

                    <button mat-icon-button color="warn" matTooltip="Excluir Item." (click)="delete(row.id)">
                        <mat-icon aria-label="Excluir Item">delete</mat-icon>
                    </button>    
                
                </ng-template>
            </ngx-datatable-column>

        </ngx-datatable>

        <div style="padding: 5px 10px">
            <mat-paginator 
                #paginator 
                [length]="length"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                (page)="pageEvent($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>